import * as Y from "yjs";
import { WaveCROpKind, decodeWaveCROpB64, } from "../blocks.js";
import { WaveCRDTBridge } from "../crdtBridge.js";
import { LOCAL_YJS_ORIGIN, createWaveYDoc, encodeFullYDocSnapshotB64, loadBlocksIntoYDoc, } from "./waveYDoc.js";
/** Reconstruct block-v1 document then materialize as Y.Doc bytes. */
export function hydrateYjsFromBlockV1(snapshot, ops) {
    const baseline = snapshot ?? { blocks: [], version: 1 };
    const bridge = new WaveCRDTBridge();
    bridge.loadSnapshotJSON(baseline);
    if (ops.length) {
        bridge.applyRemoteOps([...ops].sort((a, b) => a.seq - b.seq));
    }
    const doc = createWaveYDoc();
    loadBlocksIntoYDoc(doc, bridge.blocks);
    return Y.encodeStateAsUpdate(doc);
}
export function hydrateYjsFromBlockV1B64(snapshotB64, ops) {
    let snapshot = null;
    if (snapshotB64) {
        try {
            const json = decodeURIComponent(escape(atob(snapshotB64)));
            snapshot = JSON.parse(json);
        }
        catch {
            try {
                snapshot = JSON.parse(atob(snapshotB64));
            }
            catch {
                snapshot = null;
            }
        }
    }
    const bytes = hydrateYjsFromBlockV1(snapshot, ops);
    return btoa(String.fromCharCode(...bytes));
}
export function blocksFromBlockV1Snapshot(snapshot, ops, upToSeq) {
    const bridge = new WaveCRDTBridge();
    const maxSeq = upToSeq ?? Number.MAX_SAFE_INTEGER;
    const snap = bridge.documentAtSeq(snapshot, ops, maxSeq);
    return snap.blocks;
}
export function seedYDocFromBlocks(blocks) {
    const doc = createWaveYDoc();
    loadBlocksIntoYDoc(doc, blocks);
    return doc;
}
export function exportYDocAfterLocalEdit(doc) {
    return encodeFullYDocSnapshotB64(doc);
}
/** Detect whether an op batch is legacy block CRDT JSON vs Yjs binary update. */
export function isBlockV1OpB64(dataB64) {
    const cro = decodeWaveCROpB64(dataB64);
    if (!cro)
        return false;
    return Object.values(WaveCROpKind).includes(cro.kind);
}
export function mergeBlockV1TailIntoYDoc(doc, snapshot, tailOps) {
    const blocks = blocksFromBlockV1Snapshot(snapshot, tailOps);
    doc.transact(() => {
        loadBlocksIntoYDoc(doc, blocks);
    }, LOCAL_YJS_ORIGIN);
}
